import React from 'react';
import { Chip } from '@milanote/roma';

import { LABEL_NAME_MAX_LENGTH } from '../../../../common/labels/labelConstants';
import { getLabelColorHex } from '../../labels/labelUtils';
import SelectableChip from '../behaviours/SelectableChip';
import type { ElementLabelChipDescriptor } from '../elementChipsTypes';
import { ChipBaseProps } from '../../../../common/@roma/src/components/base/chip/ChipBase';

type LabelChipProps = {
    chip: ElementLabelChipDescriptor;
    size: ChipBaseProps['size'];
    canModify: boolean;
    /** Commits an inline rename of this label. */
    onCommitEdit: (name: string) => void;
    /** Removes this label from the owning container. */
    onRemove: () => void;
};

/**
 * Renders a label pill for the generic element pills path.
 */
const LabelChip: React.FC<LabelChipProps> = ({ chip, size, canModify, onCommitEdit, onRemove }) => {
    const { label, isSearchHighlighted } = chip;
    const labelColorHex = getLabelColorHex(label);

    return (
        <SelectableChip chip={chip} canModify={canModify} onDelete={onRemove}>
            {({ isSelected, canActivate, isEditing, setEditing, chipRef, chipProps }) => (
                <Chip
                    ref={chipRef}
                    {...chipProps}
                    editable
                    dataChipId={label._id}
                    isDisabled={!canModify || !canActivate}
                    value={label.name}
                    color={labelColorHex}
                    size={size}
                    maxLength={LABEL_NAME_MAX_LENGTH}
                    isSelected={isSelected}
                    isEditing={isEditing}
                    isSearchHighlighted={isSearchHighlighted}
                    onEditingChange={setEditing}
                    onEmptyBackspace={onRemove}
                    onCancel={() => setEditing(false)}
                    onCommit={onCommitEdit}
                />
            )}
        </SelectableChip>
    );
};

export default LabelChip;
